module.exports = __webpack_public_path__ + "img/flag-it.523635e9.svg";